var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCuenta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-circle-24-outlined"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 17.7083C52.28 17.7083 60.2083 25.6366 60.2083 35.4167C60.2083 45.1967 52.28 53.125 42.5 53.125C32.7199 53.125 24.7916 45.1967 24.7916 35.4167C24.7916 25.6366 32.7199 17.7083 42.5 17.7083ZM31.875 35.4167C31.875 29.5486 36.6319 24.7917 42.5 24.7917C48.368 24.7917 53.125 29.5486 53.125 35.4167C53.125 41.2847 48.368 46.0417 42.5 46.0417C36.6319 46.0417 31.875 41.2847 31.875 35.4167Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 3.54167C64.0161 3.54167 81.4583 20.9839 81.4583 42.5C81.4583 64.0161 64.0161 81.4583 42.5 81.4583C20.9839 81.4583 3.54163 64.0161 3.54163 42.5C3.54163 20.9839 20.9839 3.54167 42.5 3.54167ZM42.5 63.75C36.6298 63.75 31.9168 64.3851 28.3863 65.6124C26.7049 66.1969 25.2167 67.1833 24.0329 68.4792C29.2454 72.194 35.618 74.375 42.5 74.375C49.3819 74.375 55.7545 72.194 60.9643 68.4855L61.0963 68.6233C60.0644 67.4516 58.7888 66.5216 57.3477 65.8982L56.6138 65.6124C53.0831 64.3851 48.3702 63.75 42.5 63.75ZM10.625 42.5C10.625 24.8959 24.8959 10.625 42.5 10.625C60.104 10.625 74.375 24.8959 74.375 42.5C74.375 50.6716 71.3 58.1251 66.2507 63.761C64.269 61.572 61.765 59.904 58.9396 58.9218C54.5732 57.404 49.1017 56.6667 42.5 56.6667C35.8982 56.6667 30.4268 57.404 26.0605 58.9217C23.482 59.8181 21.1712 61.2856 19.2808 63.199L18.7528 63.7628C13.6987 58.122 10.625 50.6699 10.625 42.5Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCuenta);
export default __webpack_public_path__ + "static/media/cuenta.d5d8e2edfeacacf2575d30a7874a1520.svg";
export { ForwardRef as ReactComponent };